import { render, staticRenderFns } from "./ServiciosLista.vue?vue&type=template&id=563af931&"
import script from "./ServiciosLista.vue?vue&type=script&lang=js&"
export * from "./ServiciosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports